import React from 'react'
import PropTypes from 'prop-types'
import { BazaarVoiceRating } from 'components/common/Rating'

const TireRating = ({ reviewsLink, rating, showStarsOnly, ...props }) =>
  <BazaarVoiceRating
    { ...props }
    reviewsLink={ reviewsLink }
    showStarsOnly={ showStarsOnly } />


TireRating.propTypes = {
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reviewsLink: PropTypes.string,
  showStarsOnly: PropTypes.bool
}

export default TireRating
